import { useTranslation } from 'react-i18next';
import AutolistButtonStyles from 'components/styles/AutolistButton';
import { trackDealerPagesClick } from 'lib/Tracking/DealerPages';
import { DealerPagesEventType } from 'lib/EventSchema';
import TrackingDataContext from 'contexts/TrackingDataContext';
import { useContext } from 'react';
import styles from './styles';

function trackSubmitReviewClick(dealerPageUrl) {
  trackDealerPagesClick({
    type: DealerPagesEventType.write_a_review_click,
    dealerPageUrl,
  });
}

export default function SubmitReview() {
  const { t } = useTranslation();
  const { dealerPageUrl } = useContext(TrackingDataContext);

  return (
    <div className="submit-review-container">
      <div className="content">
        {t('dealerPages.familiarWithDealership')}
        <br />
        {t('dealerPages.shareYourExperience')}
      </div>
      <a
        href="https://www.research.net/r/autolist-dealer-review"
        target="_blank"
        aria-label={t('accessibility.newWindow')}
        className={`autolist-button ${AutolistButtonStyles.className}`}
        onClick={() => trackSubmitReviewClick(dealerPageUrl)}
      >
        {t('dealerPages.writeAReview')}
      </a>
      {AutolistButtonStyles.styles}
      <style jsx>{styles}</style>
    </div>
  );
}
